export default __webpack_public_path__ + "static/media/administration.bd164177.png";